// Load jQuery
import $ from 'jquery';
window.$ = window.jQuery = $;

jQuery.event.special.touchstart = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.touchmove = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.wheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("wheel", handle, { passive: true });
    }
};
jQuery.event.special.mousewheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("mousewheel", handle, { passive: true });
    }
};

//Load Libraries
import 'magnific-popup/dist/jquery.magnific-popup.min';

//Load Modules
import './modules/accordion';
import './modules/formInputs';
import './modules/galleryFilter';
import './modules/gravityForms';
import './modules/menu';
import './modules/sliders';
import './modules/videoButtonReplacer';
import './modules/videoPopup';
import './modules/videoPlay';
import './modules/accessibleAutocomplete';

//Load listing and search modules
import initListingFilters from './modules/listingFilters';
import initSearchDropdown from './modules/searchDropdown';

initListingFilters();
initSearchDropdown();
